import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import { Card } from 'reactstrap';

const AnyReactComponent = ({ text }) => <div className="mapMarker">{text}</div>;

export class LocationOnIsland extends Component {

  render () {
    return (
        <Card body style={{ height: '50vh', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyDBNtUsVcEyN-v6hyXa0-cvZHj4lzjmLgE' }}
                defaultCenter={{lat: this.props.lat, lng: this.props.lng}}
                defaultZoom={16}
                >
                <AnyReactComponent
                    lat={this.props.lat}
                    lng={this.props.lng}
                    text={this.props.listingId}/>

            </GoogleMapReact>
        </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationOnIsland.jsx